import React, { useState } from 'react';

// Importar las imágenes de talleres
import tallerPrimavera from '../assets/CU4A4010.webp';
import floresSecas from '../assets/floressecas.webp';
import tallerCoquedama from '../assets/taller_coquedama.webp';
import tallerRamoOtono from '../assets/taller_ramo_otoño.webp';
import coronasNavidad from '../assets/CORONAS.webp';
import corona01 from '../assets/CORONA01.webp';
import corona02 from '../assets/CORONA02.webp';
import ramoNavidad from '../assets/RAMONADAL.webp';
import canela from '../assets/CANELA.webp';
import magnolia from '../assets/MAGNOLIA.webp';

const Talleres = () => {
  const [selectedTaller, setSelectedTaller] = useState(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const talleres = [
    {
      id: 1,
      titulo: 'Taller de primavera',
      descripcion: '¿Cómo liberar dopamina con las flores?',
      precio: '35 €',
      duracion: '2 h',
      material: 'Material incluido',
      imagen: 'taller-primavera',
      imagenUrl: tallerPrimavera,
      imagenesSlider: [tallerPrimavera, floresSecas],
      comoFunciona: 'Realizaremos conjuntamente un ramo silvestre colorido con flores y follajes frescos de temporada seleccionados cuidadosamente. Después te lo podrás llevar a casa para disfrutar de él mientras esté fresco, y también seco, porque te enseñaremos a preservarlo para que puedas disfrutar de tu creación el máximo tiempo posible. El taller estará impartido por una florista profesional que te guiará en todo momento y te enseñará técnicas básicas de floristería.'
    },
    {
      id: 2,
      titulo: 'Taller de kokedamas',
      descripcion: 'Ven y descubre la naturaleza en tus manos',
      precio: '37 €',
      duracion: '2 h',
      material: 'Material incluido',
      imagen: 'taller-kokedama',
      imagenUrl: tallerCoquedama,
      comoFunciona: 'Conecta con la tierra y relaja tu mente. Te prometo sensaciones nuevas e inolvidables.'
    },
    {
      id: 4,
      titulo: 'Ramo Otoñal',
      descripcion: 'Elaboramos un ramo en tonos otoñales al que le podrás añadir los follajes que más te gusten.',
      precio: '39 €',
      duracion: '2 h',
      material: 'Material incluido',
      imagen: 'taller-ramo-otono',
      imagenUrl: tallerRamoOtono,
      comoFunciona: 'Utilizaremos una mezcla de materiales frescos, secos y preservados.'
    },
    {
      id: 5,
      titulo: 'Coronas navideñas',
      descripcion: '¿Ya puedes sentir el olor a pino y canela?',
      precio: '48 €',
      duracion: '2 h',
      material: 'Material incluido',
      imagen: 'coronas-navidad',
      imagenUrl: coronasNavidad,
      imagenesSlider: [coronasNavidad, corona01, corona02],
      comoFunciona: 'Eso quiere decir que la navidad ya está aquí! y junto a ella nos apetece decorar nuestras casas. En este taller nos invade el espíritu navideño, así que crearemos una corona con elementos naturales y olorosos como pino, eucalipto, piñas y mucho más. Podrás elegir el diseño y los materiales que más te gusten.'
    },
    {
      id: 6,
      titulo: 'Ramo de navidad',
      descripcion: 'Realizaremos una composición navideña y alegre para que te la puedas llevar a casa y así disfrutar de ella durante toda la temporada.',
      precio: '38 €',
      duracion: '2 h',
      material: 'Material incluido',
      imagen: 'ramo-navidad',
      imagenUrl: ramoNavidad,
      comoFunciona: 'Tendremos a tú disposición material natural y fresco, el cual te enseñaremos a secar para que puedas alargar la vida de tu arreglo navideño y así puedas disfrutarlo todo el tiempo posible.'
    },
    {
      id: 7,
      titulo: 'Centros de mesa',
      descripcion: 'Los centros navideños no pueden faltar en nuestras mesas en la noche buena, ya sean clásicos, vanguardistas o modernos siempre le dan el toque especial a nuestras fiestas.',
      precio: '48 €',
      duracion: '2 h',
      material: 'Material incluido',
      imagen: 'centros-mesa',
      imagenUrl: canela,
      imagenesSlider: [canela, magnolia],
      comoFunciona: 'En este taller aprenderás diferentes técnicas básicas para la creación de tu centro de mesa, podrás elegir entre diferentes tipos de verdes frescos y la forma y tamaño de tu diseño para vestir tu mesa la noche de navidad.'
    }
  ];

  // Función para precargar imágenes
  const preloadImages = (imageUrls) => {
    return Promise.all(
      imageUrls.map((url) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve; // Resolve even on error to avoid blocking
          img.src = url;
        });
      })
    );
  };

  const openModal = (taller) => {
    setSelectedTaller(taller);
    setCurrentSlideIndex(0);
    
    // Precargar todas las imágenes del slider
    if (taller.imagenesSlider && taller.imagenesSlider.length > 1) {
      preloadImages(taller.imagenesSlider);
    }
  };

  const closeModal = () => {
    setSelectedTaller(null);
    setCurrentSlideIndex(0);
  };

  const nextSlide = () => {
    if (selectedTaller && selectedTaller.imagenesSlider) {
      setCurrentSlideIndex((prevIndex) => 
        (prevIndex + 1) % selectedTaller.imagenesSlider.length
      );
    }
  };

  const prevSlide = () => {
    if (selectedTaller && selectedTaller.imagenesSlider) {
      setCurrentSlideIndex((prevIndex) => 
        prevIndex === 0 ? selectedTaller.imagenesSlider.length - 1 : prevIndex - 1
      );
    }
  };

  const goToSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  // Detectar dirección del swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
  };

  // Manejar click en la imagen
  const handleImageClick = (e) => {
    if (selectedTaller && selectedTaller.imagenesSlider && selectedTaller.imagenesSlider.length > 1) {
      const rect = e.currentTarget.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const imageWidth = rect.width;
      
      // Si el click está en la mitad derecha, avanza; si está en la mitad izquierda, retrocede
      if (clickX > imageWidth / 2) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  };

  const handleWhatsApp = () => {
    const mensaje = `Estoy interesado en apuntarme al próximo evento ${selectedTaller.titulo}`;
    const whatsappUrl = `https://wa.me/34634669340?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="talleres" className="talleres">
      <div className="container">
        <div className="talleres-content">
          <h2>Talleres</h2>
          
          <div className="talleres-intro">
            <div className="taller-section">
              <div className="taller-text">
                <p>Experiencias neurosensoriales</p>
                <p>Ver, oler, tocar y sentir...</p>
                <p>Estimula tu sistema nervioso con nuestros talleres.</p>
              </div>
              <div className="taller-image">
                <img src="./assets/CU4A3875.webp" alt="Experiencia neurosensorial" />
              </div>
            </div>

            <div className="taller-section text-right">
              <div className="taller-text">
                <p>Ver y oler flores estimula la liberación de dopamina, así como serotonina y endorfinas.</p>
                <p>Calma la ansiedad y el estrés con las flores.</p>
              </div>
              <div className="taller-image">
                <img src="./assets/CU4A3857.webp" alt="Flores que calman" />
              </div>
            </div>

            <div className="taller-section">
              <div className="taller-text">
                <p>Trabajar con las manos nos ayuda concentrarnos únicamente en lo que estamos haciendo, esto hace que dejemos de pensar en contratiempos o dilemas cotidianos de la vida.</p>
              </div>
              <div className="taller-image">
                <img src="./assets/CU4A3665.webp" alt="Trabajar con las manos" />
              </div>
            </div>

            <div className="taller-section text-right">
              <div className="taller-text">
                <p>Trabajar con flores es algo totalmente diferente, te cambia la manera de percibir y sentir las cosas simples de la vida.</p>
              </div>
              <div className="taller-image">
                <img src="./assets/CU4A3906.webp" alt="Trabajar con flores" />
              </div>
            </div>

            <div className="taller-section">
              <div className="taller-text">
                <p>Esta experiencia la puedes vivir en privado con las personas que elijas o junto a un grupo reducido de alumnos.</p>
              </div>
              <div className="taller-image">
                <img src="./assets/CU4A4018.webp" alt="Experiencia privada" />
              </div>
            </div>

            <div className="taller-section text-right">
              <div className="taller-text">
                <p>Trabajamos con los talleres según temporada, con las flores y elementos que nos da la naturaleza en cada época del año. En el precio del taller se incluye todo el material, el aprendizaje y un pequeño refrigerio.</p>
              </div>
              <div className="taller-image">
                <img src="./assets/CU4A4020.webp" alt="Material incluido" />
              </div>
            </div>
          </div>

          <div className="talleres-list">
            <h3>Talleres disponibles:</h3>
            <div className="talleres-grid">
              {talleres.map((taller) => (
                <div key={taller.id} className="taller-item" onClick={() => openModal(taller)}>
                  <h4>{taller.titulo}</h4>
                  <p>{taller.descripcion}</p>
                </div>
              ))}
            </div>
            
            
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedTaller && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className={`modal-content ${selectedTaller.id === 1 ? 'taller-primavera' : selectedTaller.id === 2 ? 'taller-kokedama' : selectedTaller.id === 4 ? 'taller-ramo-otono' : selectedTaller.id === 5 ? 'taller-coronas-navidad' : selectedTaller.id === 6 ? 'taller-ramo-navidad' : selectedTaller.id === 7 ? 'taller-centros-mesa' : ''}`} onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            
            <div className="modal-image">
              {selectedTaller.imagenesSlider ? (
                <div className="image-slider">
                  <div 
                    className="slider-container"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                    onClick={handleImageClick}
                  >
                    <img 
                      src={selectedTaller.imagenesSlider[currentSlideIndex]} 
                      alt={`${selectedTaller.titulo} - Imagen ${currentSlideIndex + 1}`} 
                    />
                    
                    {selectedTaller.imagenesSlider.length > 1 && (
                      <div className="slider-dots">
                        {selectedTaller.imagenesSlider.map((_, index) => (
                          <button
                            key={index}
                            className={`dot ${index === currentSlideIndex ? 'active' : ''}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              goToSlide(index);
                            }}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <img src={selectedTaller.imagenUrl} alt={selectedTaller.titulo} />
              )}
            </div>
            
            <div className="modal-info">
              <h3>{selectedTaller.titulo}</h3>
              <p className="modal-description">{selectedTaller.descripcion}</p>
              
              {selectedTaller.comoFunciona && (
                <div className="como-funciona-section">
                  <p>{selectedTaller.comoFunciona}</p>
                </div>
              )}
              
              <div className="modal-info-details">
                <div className="modal-detail">
                  <span className="precio">{selectedTaller.precio}</span>
                </div>
              <div className="modal-detail">
                <span className="duracion">{selectedTaller.duracion}</span>
              </div>
              {selectedTaller.id !== 1 && selectedTaller.id !== 2 && selectedTaller.id !== 4 && selectedTaller.id !== 5 && selectedTaller.id !== 6 && selectedTaller.id !== 7 && (
                <>
                  <div className="modal-detail">
                    <span className="material">{selectedTaller.material}</span>
                  </div>
                  <div className="modal-detail">
                    <span className="fechas">Próximas fechas disponibles</span>
                  </div>
                </>
              )}
              </div>
              
              <button className="apuntate-button" onClick={handleWhatsApp}>
                Apúntate
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Talleres;
